import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt, faPrint } from '@fortawesome/free-solid-svg-icons';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Popup from '../popup/index'; // Adjust the path based on your project structure
import { connect } from 'react-redux';
import { addfilterdata } from '../actions/filteraction';
import { logout } from '../auth/authService';

const Homenavbar = ({ records, addfilterdata, setSearchMessage }) => {
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const [searchInput, setSearchInput] = useState('');

  const handlePrint = () => {
    window.print();
  };

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const handleOpenPopup = () => {
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  const handleSearchInputChange = (e) => {
    setSearchInput(e.target.value);
  };
  const home = (e) => {
    window.location.reload();
  };

  const handleSearch = () => {
    const filtered = records.filter(record =>
      Object.values(record).some(value =>
        String(value).toLowerCase().includes(searchInput.toLowerCase())
      )
    );

    // Pass filtered data to Redux store
    addfilterdata(filtered);

    // Update search message in Homepage
    setSearchMessage(filtered.length === 0 ? 'No records found.' : '');
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark hide-on-print">
      <div className="container-fluid">
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0 d-flex">
            <li className="nav-item d-flex">
              <button className="nav-link btn fs-4 d-flex" onClick={handleOpenPopup}>Dashboard</button>             

            </li>
          </ul>
          <ul className="navbar-nav gap-3">
            <button id='home' className="nav-link btn fs-6" onClick={home} >
              Home <i className="bi bi-house"></i>
            </button>
            <li className="nav-item d-flex align-items-center">
              <div className='d-flex bg-white search-div'>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search..."
                  value={searchInput}
                  onChange={handleSearchInputChange}
                />
                <i className="bi bi-search custom-icon" onClick={handleSearch}></i>
              </div>
            </li>
            <li className="nav-item">
              <button className="nav-link custom-button" onClick={handlePrint}>
                <FontAwesomeIcon style={{ marginRight: '8px' }} icon={faPrint} />
                Print This Page
              </button>
            </li>
            <li className="nav-item">
              <button id='nav-add-button' className="nav-link" onClick={handleOpenPopup}>Add Record</button>
            </li>
            <li className="nav-item">
              <button className="btn btn-danger" onClick={handleLogout}>
                <FontAwesomeIcon style={{ marginRight: '8px' }} icon={faSignOutAlt} />
                Logout
              </button>
            </li>
          </ul>
        </div>
      </div>

      {/* Render Popup component */}
      <Popup isOpen={showPopup} onClose={handleClosePopup} />
    </nav>
  );
};

const mapStateToProps = (state) => ({
  records: state.record.records,
});

const mapDispatchToProps = dispatch => ({
  addfilterdata: (filteredRecords) => {
    dispatch(addfilterdata(filteredRecords))
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Homenavbar);
